import { asBoolean, asDate, asString, isObject } from "./model-utils";
import { Author } from "./author";

export class PollFinish {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.archive = asBoolean(json.archive);
    this.pollFinishId = asString(json.pollFinishId);
    this.pollId = asString(json.pollId);
    this.pollName = asString(json.pollName);
    this.finishDate = asDate(json.finishDate);
    this.author = Author.fromJson(json.author);
  }

  static fromJson(json: any) {
    return isObject(json) ? new PollFinish(json) : json;
  }
}
